import './RestaurantsCarousel.css';
import React, { memo, useState } from 'react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
import { isNil } from '../../utils/IsNil';
import getListing from '../../utils/getListing';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { RestaurantsCard } from '../atoms/RestaurantsCard/RestaurantsCard';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import Loader from '../atoms/Loader/Loader';
const splitter = ';,;';
const RestaurantsCarousel = /*#__PURE__*/memo(_ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = useState(true);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const dictionary = get(fields, 'data.dictionary');
  const reviews = getDictionaryItem(dictionary, 'reviews') || "";
  const title = get(fields, 'data.datasource.title.jss.value') || "";
  const subTitle = get(fields, 'data.datasource.text.jss.value') || "";
  const overviewButtonText = get(fields, 'data.datasource.buttonText.jss.value') || get(fields, 'data.overviewButton.title.jss.value');
  const overviewButtonUrl = get(fields, 'data.overviewButton.link.jss.value.href') || "";
  const overviewButtonLinktype = get(fields, 'data.overviewButton.link.jss.value.linktype') || "";
  const types = "type:Restaurant";
  const algoliaIndexes = get(params, 'SearchIndex');
  const fieldNameItem = get(fields, "data.datasource.searchFilter.targetItem.fieldNameItem.item.fieldName.value");
  const tagsToDisplay = get(fields, 'data.datasource.searchFilter.targetItem.tagsToDisplay.values') || [];
  const queryParams = tagsToDisplay.length ? tagsToDisplay.map(value => get(value, 'title.value')).join(splitter) : '';
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const carouselBackgroundColor = BackgroundColorHex ? BackgroundColorHex : "transparent";
  const navigationAnalyticsButtonClick = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['NavigationAnalytics'], params), text);
  };
  const moreButtonClickAnalytics = textArray => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ButtonClickAnalytics'], params), textArray);
  };
  const bannerAnalyticsClick = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['BannerClickAnalytics'], params), text);
  };
  const titleAnalyticsClick = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['TitleClickAnalytics'], params), text);
  };
  const favoriteAnalyticsClick = textArray => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['FavoriteClickAnalytics'], params), textArray);
  };
  const algoliaRequest = () => {
    setLoading(true);
    const category = tagsToDisplay.map(value => `${fieldNameItem}: ${value.title.value}`);
    const itemFilters = {
      facetFilters: [types, ...category],
      hitsPerPage: 8
    };
    getListing(algoliaIndexes, itemFilters, algoliaSettings).then(response => {
      setItems(response.hits);
      setLoading(false);
      setIsFirstLoad(false);
    }).catch(error => {
      console.log("error", error);
    });
  };
  React.useEffect(() => {
    algoliaRequest();
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.info('RestaurantsCarousel component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [RestaurantsCarousel component is empty: please provide data source]");
    }
    return null;
  }
  const renderItems = () => {
    if (!items.length) {
      return [];
    }
    return items.map((item, index) => /*#__PURE__*/React.createElement(RestaurantsCard, {
      key: index,
      item: item,
      params: params,
      reviews: reviews,
      rtl: rtl,
      analyticsCallback: {
        bannerAnalyticsClick,
        titleAnalyticsClick,
        favoriteAnalyticsClick
      },
      baseHrefLink: overviewButtonUrl.toLowerCase()
    }));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: {
      background: carouselBackgroundColor
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "subTitle"
  }, subTitle), /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "btn-group"
    }, renderPreviousButton(() => {
      navigationAnalyticsButtonClick("previous");
    }), renderNextButton(() => {
      navigationAnalyticsButtonClick("next");
    })), renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1601
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1600,
            min: 901
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 701
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 700,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    }), (isFirstLoad || loading) && /*#__PURE__*/React.createElement(Loader, null), !isFirstLoad && !loading && !items.length ? /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: "36px",
        fontWeight: "600",
        marginBottom: "50px"
      }
    }, "no Restaurants available") : null, /*#__PURE__*/React.createElement("div", {
      className: "paginationDot"
    }, renderDots()), /*#__PURE__*/React.createElement("div", {
      className: "overviewButton",
      onClick: () => moreButtonClickAnalytics([title, overviewButtonText])
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "btn btn-primary overviewButtonLink",
      href: `${overviewButtonUrl}?${fieldNameItem}=${queryParams}`,
      linktype: overviewButtonLinktype
    }, /*#__PURE__*/React.createElement("span", {
      className: "overviewButtonText"
    }, overviewButtonText), /*#__PURE__*/React.createElement(ChevronLeft, {
      className: "ctaChevron"
    }))));
  }));
});
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    style
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    style: style
  }, children);
};
const commonStyles = "cj61cpj";
const ltrStyles = "leysvja";
const rtlStyles = "r1u2mezf";
export default RestaurantsCarousel;